var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page-topbar"},[(_vm.showBackButton)?_c('NavigateBack',{on:{"click":_vm.onClick}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }